export const EbaySVG = () => (
  <svg
    data-testid="ebay-logo-svg"
    width={65}
    height={26}
    viewBox="0 0 65 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5029 5.67261C3.92613 5.67261 0.112305 7.61404 0.112305 13.4721C0.112305 18.1129 2.67686 21.0353 8.62085 21.0353C15.6174 21.0353 16.0658 16.4265 16.0658 16.4265H12.6758C12.6758 16.4265 11.949 18.9081 8.41416 18.9081C5.53512 18.9081 3.46447 16.9632 3.46447 14.2374H16.4206V12.5267C16.4206 9.82992 14.7086 5.67261 8.5029 5.67261ZM8.38451 7.85883C11.125 7.85883 12.9933 9.53773 12.9933 12.054H3.53936C3.53936 9.38254 5.97817 7.85883 8.38451 7.85883Z"
      fill="#E53238"
    />
    <path
      d="M16.4183 0.000244141V18.0937C16.4183 19.1207 16.345 20.5628 16.345 20.5628H19.5783C19.5783 20.5628 19.6945 19.5271 19.6945 18.5804C19.6945 18.5804 21.2921 21.0799 25.6359 21.0799C30.2101 21.0799 33.3173 17.9039 33.3173 13.3542C33.3173 9.12131 30.4633 5.71698 25.6433 5.71698C21.1297 5.71698 19.7272 8.15427 19.7272 8.15427V0.000244141H16.4183ZM24.8087 7.95493C27.915 7.95493 29.8904 10.2604 29.8904 13.3542C29.8904 16.6717 27.609 18.8419 24.831 18.8419C21.5156 18.8419 19.7272 16.2531 19.7272 13.3836C19.7272 10.7097 21.3319 7.95493 24.8087 7.95493Z"
      fill="#0064D2"
    />
    <path
      d="M41.3533 5.67261C34.468 5.67261 34.0265 9.4425 34.0265 10.0451H37.4535C37.4535 10.0451 37.6332 7.84411 41.1169 7.84411C43.3806 7.84411 45.1348 8.88041 45.1348 10.8723V11.5813H41.1169C35.7828 11.5813 32.9629 13.1418 32.9629 16.3085C32.9629 19.4248 35.5684 21.1203 39.0896 21.1203C43.8884 21.1203 45.4342 18.4688 45.4342 18.4688C45.4342 19.5235 45.5153 20.5628 45.5153 20.5628H48.5619C48.5619 20.5628 48.4439 19.2746 48.4439 18.4504V11.3266C48.4439 6.65544 44.6762 5.67261 41.3533 5.67261ZM45.1348 13.7085V14.6539C45.1348 15.8869 44.3739 18.9525 39.8945 18.9525C37.4416 18.9525 36.3899 17.7283 36.3899 16.3083C36.3899 13.7251 39.9315 13.7085 45.1348 13.7085Z"
      fill="#F5AF02"
    />
    <path
      d="M46.5984 6.26465H50.4538L55.987 17.3501L61.5074 6.26465H65L54.9446 26.0002H51.281L54.1825 20.4986L46.5984 6.26465Z"
      fill="#86B817"
    />
  </svg>
)
